/**
 * Created by Yoyo Fang on 11/11/2019.
 * Description:
 *  implement interface of dashboard tiles for tam dashboard value tile
 * ------ maintenance history ------
 */
import { DashboardTileAction, TamDashboardBaseConfiguration } from '../tam-dashboard-tile.base.config';
import { Subject, Subscription } from 'rxjs';
import { TamDashboardActions, TamDashboardEvents, TamDashboardTileType } from '../tam-dashboard.model';
import { filter } from 'rxjs/operators';
import { DashboardActionTypes } from '../../../redux/actions/dashboard.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../../redux';
import { DashboardTileService } from '../dashboard-tile.service';

export class TamDashboardValueTileConfiguration implements TamDashboardBaseConfiguration {

    public data: any;
    public id: string;
    public initialized: boolean;
    public name: string;
    public readonly: boolean;
    public actionSubject$: Subject<any>;
    public feedbackSubject$: Subject<any>;
    public seriesClickEventType?: string;
    public subscriptions: Subscription[] = [];

    private _focusedEntityIds: any;
    private _tileConfig: any;

    constructor(
        private _dashboardTileService: DashboardTileService,
        private _store?: Store<AppState>
    ) {
        this.initialized = false;
    }

    destroy() {
        this.subscriptions.forEach((subscription: Subscription) => {
            if (subscription && !subscription.closed) {
                subscription.unsubscribe();
            }
        });
    }

    init(id: string, readonly: boolean, name: string, actionSubject$: Subject<any>, feedbackSubject$: Subject<any>): boolean {
        if (this.initialized === false) {
            this.id = id;
            this.readonly = readonly;
            this.name = name;
            this.actionSubject$ = actionSubject$;
            this.feedbackSubject$ = feedbackSubject$;
            const actionSubscription = this.actionSubject$.pipe(
                filter((action: any) => action && action.id === this.id)
            ).subscribe((action) => this._actionHandler(action));
            this.subscriptions.push(actionSubscription);
            this.initialized = true;
            return true;
        } else {
            return false;
        }
    }

    onSeriesClick() {
        /** data value is null, can't click to expand drill down dialog
         * data value is 0, can click to expand drill down dialog
         */
        if (!this.readonly || !this.data || this.data.value === null) {
            return;
        }
        this.feedbackSubject$.next({
            type: this.seriesClickEventType || TamDashboardEvents.OPEN_DRILL_DOWN,
            payload: {
                id: this.id,
                type: TamDashboardTileType.VALUE.toString(),
                name: this.name,
                readonly: this.readonly,
                tileConfig: this._tileConfig,
                focusedEntityIds: this._focusedEntityIds,
                actionSubject$: this.actionSubject$,
                feedbackSubject$: this.feedbackSubject$,
                data: this.data
            }
        });
    }

    setTileData(data) {
        this.actionSubject$.next({
            id: this.id,
            type: TamDashboardActions.SET_TILE_DATA,
            payload: data
        });
    }

    private _actionHandler(action: DashboardTileAction) {
        switch (action.type) {
            case TamDashboardActions.LOAD_DATA: {
                if (action.payload && action.payload['tileConfig']) {
                    this._loadData(action.payload);
                }
                break;
            }
            case TamDashboardActions.SET_TILE_DATA: {
                if (!action.payload) {
                    action.payload = { data: null, fontSizeCalculator: this._dashboardTileService.getFontSizeCalculator('N/A') };
                }
                this.data = action.payload.data;
                break;
            }
            case TamDashboardActions.SET_TILE_CONFIG: {
                this._tileConfig = action.payload;
                break;
            }
            case TamDashboardActions.SET_FOCUSED_ENTITY_IDS: {
                this._focusedEntityIds = action.payload;
                break;
            }
        }
    }

    private _loadData({ tileConfig, focusedEntityIds, useConfig, saveStore = false }) {
        this._dashboardTileService.valueTileLoadData(tileConfig, focusedEntityIds, useConfig).subscribe((result: any) => {
            if (saveStore && result && result.data && this._store) {
                this._store.dispatch({
                    type: DashboardActionTypes.SAVE_TILE_DATA,
                    payload: {
                        id: this.id,
                        data: result
                    }
                });
            }
            this.setTileData(result);
        });
    }
}
